import {capitalize} from 'lodash/string';
import {fromJS} from 'immutable';

export const setRecordsReducer = (recordType, state, action) => {
  const {records, currentPage, pageCount, totalCount, itemsPerPage} = action;
  let sortedIds = [],
    newRecordPage = {};
  for (let record of records) {
    sortedIds.push(record.id);
    newRecordPage[record.id] = record;
  }
  newRecordPage['sortedIds'] = sortedIds;
  const key = `${recordType}Pages`;
  const stateObj = state.toJS();
  return fromJS({
    ...stateObj,
    [key]: {
      ...stateObj[key],
      [currentPage]: newRecordPage,
      currentPage,
      totalCount,
      pageCount,
      itemsPerPage,
    },
  });
};

export const setCurrentRecordPageReducer = (recordType, state, action) => {
  const key = `${recordType}Pages`;
  const stateObj = state.toJS();
  return fromJS({
    ...stateObj,
    [key]: {
      ...stateObj[key],
      currentPage: action.page,
    },
  });
};

export const setCurrentRecordReducer = (recordType, state, action) => {
  const key = `${recordType}Pages`;
  const stateObj = state.toJS();
  return fromJS({
    ...stateObj,
    [`current${capitalize(recordType)}`]: action.recordData
      ? action.recordData
      : {
          ...stateObj[key][stateObj[key].currentPage][action.recordId],
        },
  });
};

export const clearRecordsAfterPageReducer = (recordType, state, action) => {
  const key = `${recordType}Pages`;
  const page = parseInt(action.page) || 0;
  const stateObj = state.toJS();
  const pageNumbers = Object.keys(stateObj[key]).filter((v) => {
    const parsed = parseInt(v);
    return !isNaN(parsed) && parsed <= page;
  });
  const recordPages = pageNumbers.reduce(
    (obj, num) => ({
      ...obj,
      [num]: {
        ...stateObj[key][num],
      },
    }),
    {},
  );
  return fromJS({
    ...stateObj,
    [key]: {
      ...recordPages,
      currentPage: page || 1,
      totalCount: stateObj[key].totalCount,
      pageCount: stateObj[key].pageCount,
      itemsPerPage: stateObj[key].itemsPerPage,
    },
  });
};
